import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/reducers';
import { Alert } from '@patternfly/react-core';
import SplashPage from '../splash/SplashPage';
import { getIsLoggedIntoAtLeastOneAppAuth } from '../../store/selectors';
import { useTranslation } from 'react-i18next';

/** Wrapper component to use when the app requires cloud authentication. Otherwise use NoAuthPage. */
const AuthenticatedPage = (props: React.PropsWithChildren<{}>) => {
    const { t } = useTranslation();

    // const auths = useSelector((state: StoreState) => state.appAuthStates);
    const loginError = useSelector((state: StoreState) => state.loginError);

    const isWaitingForLogin = !useSelector(getIsLoggedIntoAtLeastOneAppAuth);
    const wasLoginSuccessful = loginError === null;
    const arePopupsBlocked = !wasLoginSuccessful && loginError && loginError.arePopupsBlocked;
    const loginErrorMessage = !wasLoginSuccessful && !arePopupsBlocked && loginError && loginError.errorMessage;
    // const isWaitingForLogin = appAuthStatesCollection.areAppStartLoginsPending();
    // const hasUserAuthenticated = !isWaitingForLogin && this.props.user && this.props.user as User && (this.props.user as User).isAuthenticated;

    // const isWaitingForLogin = true;
    // const hasUserAuthenticated = true;

    const googleChromeSupportUrl = 'https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DDesktop&hl=en#zippy=%2Callow-pop-ups-from-a-site';

    return (
        <>
            {arePopupsBlocked && (<Alert variant="danger" title={t('error.popupsBlocked.title')}>
                <p>{t('error.popupsBlocked.paragraph1', { appName: t('appTitle') })}</p>
                <p>{t('error.popupsBlocked.paragraph2')}</p>
                <p><a href={googleChromeSupportUrl} target="_blank" rel="noopener noreferrer">{googleChromeSupportUrl}</a></p>
                <p>{t('error.popupsBlocked.paragraph3')}</p>
                <p>{t('error.popupsBlocked.paragraph4', { appName: t('appTitle') })}</p>
            </Alert>)}
            {!wasLoginSuccessful && loginErrorMessage && (<Alert variant="danger" title={t('error.loginError.title', { loginErrorMessage: loginErrorMessage })}>
                <p>{t('error.loginError.paragraph1')}</p>
                <p>{loginErrorMessage}</p>
                <p>{t('error.loginError.paragraph2')}</p>
            </Alert>)}
            {isWaitingForLogin && (<SplashPage loadingText={t('splash.waitingForLogin')} />)}
            {/*hasUserAuthenticated &&*/ !isWaitingForLogin && props.children}
        </>
    );
}

export default AuthenticatedPage;
